import React, { Fragment } from 'react';
import { templatePropTypes } from '../../utilities/commonPropTypes';
import { Shared4x3Fragment } from '../commonFragments';

const Desktop4x3 = ({
	applicableVehicle,
	promoIndex,
	couponCode = '',
	ctaButtonData,
	description,
	discountDisplay = '',
	imageUrl,
	offerDetails,
	promo,
	incentive = {},
	title,
	type,
	vehicleImages = [],
	width,
	height,
	triggerPrint,
	vehicleBackgroundImage,
	modelOfferBackgroundImage
}) => {
	return (
		<Fragment>
			{Shared4x3Fragment({
				applicableVehicle,
				promoIndex,
				couponCode,
				ctaButtonData,
				description,
				discountDisplay,
				imageUrl,
				offerDetails,
				promo,
				incentive,
				title,
				type,
				vehicleImages,
				width,
				height,
				triggerPrint,
				vehicleBackgroundImage,
				modelOfferBackgroundImage
			})}
		</Fragment>
	);
};

Desktop4x3.propTypes = templatePropTypes;

export default Desktop4x3;
